import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import AuthDesktop from './auth.desktop'
import AuthMobile from './auth.mobile'
import useGoogleAuth from '../../_hooks/useGoogleAuth'
import { IUser } from '../../_store/types'

const Auth = ({
  open = false,
  onClose,
  onLastConfirm = () => {},
}: {
  open: boolean
  onClose: () => void
  onLastConfirm?: (data: IUser) => void
}) => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  useGoogleAuth()

  return (
    <>
      {isDesktop ? (
        <AuthDesktop
          open={open}
          onClose={onClose}
          onLastConfirm={onLastConfirm}
        />
      ) : (
        <AuthMobile
          open={open}
          onClose={onClose}
          onLastConfirm={onLastConfirm}
        />
      )}
    </>
  )
}

export default Auth
